<style lang="scss" scoped>
.fw-text {
  font-family: 'Consolas';
  font-size: 12px;
}
</style>

<template>
  <b-modal v-model="show" no-close-on-esc no-fade size="lg">
    <div slot="modal-title">
      <h6>Key Generator</h6>
    </div>

    <b-container fluid>
      <b-form-row>
        <b-col cols="6">
          <b-form-group label="Event">
            <b-form-select v-model="eventId" :options="eventsHidden" />
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <b-form-group label="Expiration Date">
            <datepicker
              v-model="expDate"
              bootstrap-styling
              calendar-button
              calendar-button-icon="fa fa-calendar"
              clear-button
              clear-button-icon="fa fa-times"
              format="dd-MMM-yyyy"
              input-class="form-control bg-white" />
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row v-if="token" class="mt-2">
        <b-col>
          <div />
          <b-card>
            <div class="flash">
              <b-link :href="`${token.url}`" target="_blank">
                {{ token.url }}
              </b-link>
            </div>
          </b-card>
          <b-form-text>Valid until {{ token.expiration }}</b-form-text>
        </b-col>
      </b-form-row>
    </b-container>

    <div v-if="token">
      <input id="url" type="hidden" :value="token.url" />
    </div>

    <div slot="modal-footer">
      <b-btn :disabled="!eventId || !expDate" variant="primary" @click="getToken"> Generate Link </b-btn>
      <b-btn class="ml-1" :disabled="!token" @click="copy()"> Copy </b-btn>
    </div>
  </b-modal>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

import {mapState} from 'vuex'
import {addDays, endOfDay} from 'date-fns'
import store from '@/store/store'
import helper from '@/lib/helper'

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      eventId: null,
      expDate: addDays(new Date(), 7),
    }
  },
  computed: {
    ...mapState('ftoggle', ['token']),

    eventsHidden() {
      const events = store.getters.eventsHidden
      const a = events.map((x) => ({
        value: x.id,
        text: x.name,
        closed: x.closed,
      }))

      if (a.length == 1) {
        this.eventId = a[0].value
      }
      return a
    },
    show: {
      get() {
        return store.state.ftoggle.show
      },
      set(b) {
        store.commit('ftoggle/show', b)
      },
    },
  },
  methods: {
    async getToken() {
      const pyl = {
        eventId: this.eventId,
        tacId: helper.tacId(),
        expDate: endOfDay(this.expDate),
      }
      await store.dispatch('ftoggle/generateToken', pyl)
    },
    fmtDate(s) {
      return helper.fmtDate(s)
    },
    copy() {
      const el = document.querySelector('#url')
      if (!el) return

      el.setAttribute('type', 'text')
      el.select()

      document.execCommand('copy')
      el.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
  },
}
</script>
